






















import Vue from 'vue'
import Component from 'vue-class-component'
import skills from '@/static/skills.ts'

@Component({})
export default class Skills extends Vue {
  isLoaded = false
  skills = skills;

  mounted () {
    setTimeout(() => {
      this.isLoaded = true
    }, 100)
  }
}
